import config from "@Config/index";
import axios from "axios";

export const filterActiveChildInventories = (inventories: any) => {
  let isArray = true;
  if (!inventories) {
    inventories = [];
  }
  if (!Array.isArray(inventories)) {
    isArray = false;
    inventories = [inventories];
  }

  inventories.forEach((inventory: any) => {
    if (inventory.active_children_count >= 0) {
      inventory.children_count = inventory.active_children_count;
    }
    if (inventory.active_children) {
      inventory.children = inventory.active_children.map((conf: any) => {
        if (conf.active_children_count >= 0) {
          conf.children_count = conf.active_children_count;
        }
        if (conf.active_children) {
          conf.children = conf.active_children;
          conf.children_count = conf.children.length;
        }
        return conf;
      });
      inventory.children_count = inventory.children.length;
    }
  });
  return isArray ? inventories : inventories[0];
};

const getInventories = async (options: any) => {
  const clonedOptions = { ...options };
  let updatedFilters;
  // handling meta_unit_types filters explicitly as we need to send comma seperated 3 values for student accomodation filter.
  if (options?.filters) {
    const unitTypes = clonedOptions?.filters?.["meta_unit_types"];
    updatedFilters = unitTypes?.split(",").includes("student_accommodation")
      ? `${unitTypes},apartment,university_hall`
      : unitTypes;
    clonedOptions["filters"]["meta_unit_types"] = updatedFilters;
  }
  const selectedOption: any = options?.filters ? clonedOptions : options;

  const finalOptions = {
    ...selectedOption,
    params: {
      ...(selectedOption.params || {}),
      use_java_api: true,
    },
    headers: { ...(selectedOption.headers || {}), "X-Use-Java-Api": "true" },
  };
  return axios.get(`${config.API_URL}/api/v1/inventories`, finalOptions);
};

export default getInventories;
